import { formatNumber } from './formatters.js';

/**
 * Short unit label for document lines ("Std.", "Stk.", "pauschal").
 * Unknown/custom codes render as-is; missing unit renders nothing.
 */
export function unitShort(t, unit) {
  if (!unit) return '';
  const key = `uom.short.${unit}`;
  const label = t(key);
  return label === key ? unit : label;
}

/** "5 Std." / "1 pauschal" / bare "5" when the line has no unit (legacy). */
export function formatQty(t, quantity, unit) {
  const qty = formatNumber(quantity);
  const label = unitShort(t, unit);
  return label ? `${qty} ${label}` : qty;
}
